import React from "react";
import { Button, Segment } from "semantic-ui-react";
import { Warning } from "../../../components";

export default function Confirmation(props) {
  const { accepted, cashTotal, dealer, months, totalMonthlyPayment } = props;

  if (
    !cashTotal ||
    !months ||
    !totalMonthlyPayment ||
    !props.startDate ||
    !props.routingNumber ||
    !props.accountNumber ||
    !dealer
  ) {
    return (
      <Warning
        showButton={false}
        subheader="You haven't entered required information"
      >
        <Button basic content="Close" onClick={props.onClose} />
      </Warning>
    );
  }

  return (
    <Segment padded>
      {props.accepted && (
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "1.35em" }}>
            By generating this signed contract, I attest that I understand I am
            agreeing to the total amount of ${cashTotal} to be paid over{" "}
            {months} months at ${totalMonthlyPayment} per month.
          </p>
          <p style={{ fontSize: "1.35em" }}>
            <b>Routing Number</b>: {props.routingNumber}
            <br />
            <b>Account Number</b>: {props.accountNumber}
            <br />
            <b>Payment Due Date Each Month</b>: {props.startDate}
          </p>
        </div>
      )}
      {!props.accepted && (
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "1.35em" }}>
            By clicking ok, I am attesting that I, as a representative of{" "}
            <b>{dealer}</b>, have ensured, to the best of my ability, verified
            the signer of this contract's identity. After clicking I accept,
            pass the device to the customer.
          </p>
        </div>
      )}
      <Button
        color="green"
        size="huge"
        icon="checkmark"
        content={props.accepted ? "Generate The Contract" : "I Accept"}
        onClick={props.accepted ? props.onSubmit : props.setAccepted}
        fluid
        labelPosition="right"
        style={{
          margin: "50px 0 15px 0",
        }}
      />
      <Button
        negative
        content="I Decline"
        onClick={props.onClose}
        fluid
        labelPosition="right"
        icon="thumbs down"
        size="huge"
      />
    </Segment>
  );
}
